/* globals OldSoundManager, loader */

require('./sound-fallback');

var SoundManager = window.SoundManager = function(sounds, gametype, callback) {
	if (typeof AudioContext === 'undefined') {
		window.AudioContext = window.AudioContext || window.webkitAudioContext;
	}
	
	if (typeof AudioContext !== 'undefined') {
		this.context = new AudioContext();
	}
	
	if (!this.context) {
		console.log('Setting SoundManager to legacy mode.');
		
		return new OldSoundManager(gametype, callback);
	}
	
	var audio = new Audio();
	
	this.path = base;
	
	if (!audio.canPlayType('audio/mpeg')) {
		return callback && callback(false);
	}
	
	if (!this.context.createGain && this.context.createGainNode) {
		this.context.createGain = this.context.createGainNode;
	}
	
	this.ready = false;
	
	var gain = this.context.createGain();
	gain.connect(this.context.destination);
	this.gain = gain.gain;
	
	this.destination = gain;
	
	this.sounds = {};
	this.sources = {};
	
	this.requested = 0;
	this.responsed = 0;
	
	this.callback = callback;
	
	this.loadSounds(sounds);
};

SoundManager.prototype.volume = function(value) {
	this.gain.value = value;
};

SoundManager.prototype.loaded = function() {
	if (!this.context) {
		return this;
	}
	
	if (this.responsed !== this.requested) {
		return this;
	}
	
	this.ready = true;
	
	if (this.callback) {
		this.callback(this.requested);
	}
	
	return this;
};

SoundManager.prototype.loadSounds = function(sounds, prefix, base, store) {
	if (!this.context) {
		return this;
	}
	
	if (!sounds) {
		return this;
	}
	
	if (typeof store === 'undefined') {
		store = this.sounds;
	}
	
	if (prefix && typeof prefix === 'string') {
		prefix = [ prefix ];
	}
	
	if (!prefix) {
		prefix = [];
	}
	
	for (var name in sounds) {
		prefix.push(name);
		
		if (sounds[name] === null) {
			delete store[name];
		}
		
		else if (sounds[name] instanceof Array) {
			if (!store[name]) {
				store[name] = [];
			}
			
			for (var i = 0; i < sounds[name].length; i++) {
				if (sounds[name][i] === null) {
					delete store[name][i];
					continue;
				}
				
				prefix.push(i);
				store[name][i] = sounds[name][i];
				this._load(prefix, store[name], i);
				prefix.pop();
			}
		}
		
		else if (typeof sounds[name] === 'object') {
			if (!store[name]) {
				store[name] = {};
			}
			
			this.loadSounds(sounds[name], prefix, base, store[name]);
		}
		
		else if (typeof sounds[name] === 'string') {
			store[name] = sounds[name];
			this._load(prefix, store, name);
		}
		
		prefix.pop();
	}
	
	return this;
};

SoundManager.prototype._load = function(prefix, store, key) {
	if (!this.context) {
		return this;
	}
	
	loader.count(true);
	loader.count(true);
	this.requested++;
	
	store[key] = this.path + store[key];
	
	var request = new XMLHttpRequest();
	request.open('GET', store[key], true);
	request.responseType = 'arraybuffer';
	
	var that = this;
	request.onerror = function() {
		delete store[key];
		loader.count(false);
		loader.count(false);
		that.responsed++;
		that.loaded();
	};
	
	var original = store[key];
	request.onload = function() {
		loader.count(false);
		
		/* jscs:disable requirePaddingNewLinesAfterBlocks */
		that.context.decodeAudioData(request.response, function(buffer) {
			if (store[key] === original) {
				store[key] = buffer;
			}
			
			loader.count(false);
			that.responsed++;
			that.loaded();
		}, function() {
			if (store[key] === original) {
				delete store[key];
			}
			
			loader.count(false);
			that.responsed++;
			that.loaded();
		});
		/* jscs:enable requirePaddingNewLinesAfterBlocks */
	};
	
	request.send();
	
	return this;
};

SoundManager.prototype._play = function(buffer, options) {
	if (!options) {
		options = { };
	}
	
	if (typeof options === 'number') {
		options = { time: options };
	}
	
	if (typeof options === 'boolean') {
		options = { loop: options };
	}
	
	if (options.time) {
		options.time += this.context.currentTime;
	}
	
	else {
		options.time = 0;
	}
	
	var source = this.context.createBufferSource();
	source.buffer = buffer;
	
	if (options.loop) {
		source.loop = true;
	}
	
	if (source.gain) {
		source.connect(this.destination);
	}
	
	else {
		var gain = this.context.createGain();
		gain.connect(this.destination);
		source.connect(gain);
		
		source.gain = gain.gain;
	}
	
	if (options.gain) {
		source.gain.value = options.gain;
	}
	
	if (!source.start && source.noteOn) {
		source.start = source.noteOn;
	}
	
	if (options.detune && source.detune) {
		source.detune.value = options.detune;
	}
	
	source.playing = true;
	source.start(options.time);
	
	return source;
};

SoundManager.prototype._stop = function(source, options) {
	if (!options) {
		options = { };
	}
	
	if (typeof options === 'number') {
		options = { time: options };
	}
	
	if (options.time) {
		options.time += this.context.currentTime;
	}
	
	else {
		options.time = 0;
	}
	
	if (!source.stop && source.noteOff) {
		source.stop = source.noteOff;
	}
	
	if (source.constructor.prototype.hasOwnProperty('isPrototypeOf')) {
		for (var s in source) {
			if (source[s].playing) {
				this._stop(source[s], options);
				source[s].playing = false;
			}
		}
	}
	
	else {
		if (source.playing) {
			source.stop(options.time);
			source.playing = false;
		}
	}
	
	return this;
};

SoundManager.prototype._source = function(path, buff) {
	var source = this.sources;
	var buffer = buff ? this.sounds : null;
	
	for (var p = 0; p <= path.length - (buff ? 2 : 1); p++) {
		if (!source[path[p]]) {
			if (buff) {
				source[path[p]] = {};
			}
			
			else {
				return null;
			}
		}
		
		source = source[path[p]];
		
		if (buff) {
			if (!buffer[path[p]]) {
				return null;
			}
			
			buffer = buffer[path[p]];
		}
	}
	
	if (buff) {
		if ((typeof path[path.length - 1] !== 'number' || buffer.constructor !== Object) && !buffer[path[path.length - 1]]) {
			return null;
		}
		
		return [ source, buffer ];
	}
	
	else {
		return source;
	}
};

SoundManager.prototype.fade = function(path, start, end, time) {
	if (!this.context || !this.ready) {
		return this;
	}
	
	if (typeof path === 'string') {
		path = [ path ];
	}
	
	var source = this._source(path);
	
	if (!source) {
		return this;
	}
	
	var now = this.context.currentTime;
	source.gain.setValueAtTime(start, now);
	source.gain.linearRampToValueAtTime(end, now + time);
	
	return this;
};

SoundManager.prototype.play = function(path, options) {
	if (!this.context || !this.ready) {
		return this;
	}
	
	if (typeof path === 'string') {
		path = [ path ];
	}
	
	var temp = this._source(path, true);
	
	if (!temp) {
		return null;
	}
	
	var source = temp[0];
	var buffer = temp[1];
	
	if (!buffer[path[path.length - 1]]) {
		if (typeof path[path.length - 1] === 'number' && buffer.constructor === Array) {
			path[path.length - 1] = path[path.length - 1] % buffer.length;
		}
		
		else if (typeof path[path.length - 1] === 'number' && buffer.constructor === Object) {
			for (var k in buffer) {
				if (path[path.length - 1] >= k) {
					path[path.length - 1] = k;
					break;
				}
			}
			
			if (!buffer[path[path.length - 1]]) {
				return null;
			}
		}
		
		else {
			return null;
		}
	}
	
	buffer = buffer[path[path.length - 1]];
	
	if (buffer instanceof Array) {
		var i = Math.floor(Math.random() * buffer.length);
		buffer = buffer[i];
	}
	
	if (typeof buffer === 'string') {
		return null;
	}
	
	source[path[path.length - 1]] = this._play(buffer, options);
	
	return source[path[path.length - 1]];
};

SoundManager.prototype.stop = function(path, options) {
	if (!this.context || !this.ready) {
		return this;
	}
	
	if (typeof path === 'string') {
		path = [ path ];
	}
	
	var source = this._source(path);
	
	if (!source) {
		return this;
	}
	
	this._stop(source, options);
	
	return this;
};



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/common/sound/sound.js
 **/